import Button from './Button';
import ButtonSubmit from './ButtonSubmit';

export default Button;
export {Button, ButtonSubmit};



// WEBPACK FOOTER //
// ./src/shared/components/buttons/index.ts